<template>
  <transition name="appear" mode="out-in">
    <a v-scroll-to="'body'" title="Наверх" class="raise" v-if="isVisible"></a>
  </transition>
</template>

<script>
export default {
  name: 'ScrollToTop',
  data () {
    return {
      footerHeight: '',
      isVisible: false
    }
  },
  mounted () {
    window.onscroll = () => {
      this.isVisible = (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300)
    }
  }
}
</script>

<style lang="scss" scoped>
  .raise {
    display: block;
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: 50;
    width: 50px;
    height: 50px;
    border: 5px solid #bad7f9;
    border-radius: 50%;
    opacity: .4;
    cursor: pointer;
    text-decoration: none;

    @media screen and (min-width: 768px){
      bottom: 65px;
    }

    &:before {
      content: '';
      position: absolute;
      left: 50%;
      top: 5px;
      margin: -6px 0 0 -10px;
      border: 10px solid transparent;
      border-bottom: 18px solid #bad7f9;
    }
  }

  .appear-enter-active,
  .appear-leave-active {
    transition: opacity 0.7s;
  }
  .appear-enter,
  .appear-leave-to {
    opacity: 0;
  }
</style>
